<template>
  <v-app class="fondo_m">
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'app',
};
</script>
<style scoped>
.fondo_m{
  background-image: url('../assets/fondo.png');
  background-repeat: repeat; 
}
</style>